import type { CcgSupportedLocale } from '../types/CcgSupportedLocale';

export const isCcgLocale = (
  locale: string | null,
): locale is CcgSupportedLocale => {
  return locale === 'en' || locale === 'es';
};
